import { render, staticRenderFns } from "./AppAuthorization.vue?vue&type=template&id=3d2fa202&scoped=true"
import script from "./AppAuthorization.vue?vue&type=script&lang=js"
export * from "./AppAuthorization.vue?vue&type=script&lang=js"
import style0 from "./AppAuthorization.vue?vue&type=style&index=0&id=3d2fa202&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fa202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2fa202')) {
      api.createRecord('3d2fa202', component.options)
    } else {
      api.reload('3d2fa202', component.options)
    }
    module.hot.accept("./AppAuthorization.vue?vue&type=template&id=3d2fa202&scoped=true", function () {
      api.rerender('3d2fa202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatOpenPlatform/components/AppAuthorization.vue"
export default component.exports